export const ERROR_CODES = {
  toppingMaxLimit: '501_OM',
} as const;
